export default __webpack_public_path__ + "static/screenshot_4d-486b99ae892a570d482fbde9d480a56d.png";